import React from "react"
import { BlurFade } from "./magicui/blur-fade.tsx"
import { TextReveal } from "./magicui/text-reveal.tsx"
import "./Services.css"
import { useTranslation } from "react-i18next"


const Services = () => {

  const { t, i18n } = useTranslation()

  return (
    <section className="services-section">
      <div className="absolute -top-1 rotate-180 w-full">
        <div id="cloud_top"></div>
      </div>

      <div className="absolute bottom-0 w-full">
        <div id="cloud_bottom"></div>
      </div>
      
      <div className="services-child-main-container">
        

        <div className="container-sc-c">
          <BlurFade delay={0.25} inView>
          <div className="section-title-services-container">
            <div className="mini-title-services">
              {t('home.services.title_card')}
            </div>
            <div>
              <h2 className="section-main-title-services">
                {t('home.services.main_title')}
              </h2>
            </div>
          </div>
        </BlurFade>
          <div className="cards-services-container">
            <BlurFade delay={0.25} className="card-services" inView>
                <div className="parent-card">
                  <div className="front-card">
                    <div id="bg-serv-1"></div>
                    <div className={`${i18n.language === "ar" ? "content-card-ar" : "content-card"}`}>
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21.6 21.6" fill="none" stroke="#FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-landmark-icon lucide-landmark"><path d="M9 16.2v-6.3"/><path d="M10.008 1.978a1.8 1.8 0 0 1 1.584 0.005l7.079 3.462c0.428 0.21 0.279 0.854 -0.198 0.854H3.127c-0.477 0 -0.625 -0.644 -0.198 -0.854z"/><path d="M12.6 16.2v-6.3"/><path d="M16.2 16.2v-6.3"/><path d="M2.7 19.8h16.2"/><path d="M5.4 16.2v-6.3"/></svg>
                      </div>
                      <div className="title-card">
                        {t('home.services.section.cards.one.front')}
                      </div>
                    </div>
                  </div>
                  <div className="back-card">
                    <div id="bg-serv-1"></div>
                    <div className={`${i18n.language === "ar" ? "content-card-ar" : "content-card"}`}>
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21.6 21.6" fill="none" stroke="#FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-landmark-icon lucide-landmark"><path d="M9 16.2v-6.3"/><path d="M10.008 1.978a1.8 1.8 0 0 1 1.584 0.005l7.079 3.462c0.428 0.21 0.279 0.854 -0.198 0.854H3.127c-0.477 0 -0.625 -0.644 -0.198 -0.854z"/><path d="M12.6 16.2v-6.3"/><path d="M16.2 16.2v-6.3"/><path d="M2.7 19.8h16.2"/><path d="M5.4 16.2v-6.3"/></svg>
                      </div>
                      <div className="title-card">
                        {t('home.services.section.cards.one.back')}
                      </div>
                    </div>
                  </div>
                </div>
            </BlurFade>
            <BlurFade delay={0.50} className="card-services" inView>
                <div className="parent-card">
                  <div className="front-card">
                    <div id="bg-serv-2"></div>
                  <div className={`${i18n.language === "ar" ? "content-card-ar" : "content-card"}`}>
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21.6 21.6" fill="none" stroke="#FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-graduation-cap-icon lucide-graduation-cap"><path d="M19.278 9.83a0.9 0.9 0 0 0 -0.017 -1.654L11.547 4.662a1.8 1.8 0 0 0 -1.494 0L2.34 8.172a0.9 0.9 0 0 0 0 1.649l7.713 3.517a1.8 1.8 0 0 0 1.494 0z"/><path d="M19.8 9v5.4"/><path d="M5.4 11.25V14.4a5.4 2.7 0 0 0 10.8 0v-3.15"/></svg>
                    </div>
                    <div className="title-card">
                      {t('home.services.section.cards.two.front')}
                    </div>
                  </div>
                  </div>
                  <div className="back-card">
                    <div id="bg-serv-2"></div>
                    <div className={`${i18n.language === "ar" ? "content-card-ar" : "content-card"}`}>
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21.6 21.6" fill="none" stroke="#FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-graduation-cap-icon lucide-graduation-cap"><path d="M19.278 9.83a0.9 0.9 0 0 0 -0.017 -1.654L11.547 4.662a1.8 1.8 0 0 0 -1.494 0L2.34 8.172a0.9 0.9 0 0 0 0 1.649l7.713 3.517a1.8 1.8 0 0 0 1.494 0z"/><path d="M19.8 9v5.4"/><path d="M5.4 11.25V14.4a5.4 2.7 0 0 0 10.8 0v-3.15"/></svg>
                      </div>
                      <div className="title-card">
                        {t('home.services.section.cards.two.back')}
                      </div>
                    </div>
                  </div>
                </div>
            </BlurFade>
            <BlurFade delay={0.75} className="card-services" inView>
                <div className="parent-card">
                  <div className="front-card">
                    <div id="bg-serv-3"></div>
                    <div className={`${i18n.language === "ar" ? "content-card-ar" : "content-card"}`}>
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 20.4 20.4" fill="none" stroke="#FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-wrench-icon lucide-wrench"><path d="M12.495 5.355a0.85 0.85 0 0 0 0 1.19l1.36 1.36a0.85 0.85 0 0 0 1.19 0l3.204 -3.204a5.1 5.1 0 0 1 -6.749 6.749l-5.873 5.873a1.802 1.802 0 0 1 -2.55 -2.55l5.873 -5.873a5.1 5.1 0 0 1 6.749 -6.749l-3.196 3.196z"/></svg>
                      </div>
                      <div className="title-card">
                        {t('home.services.section.cards.three.front')}
                      </div>
                    </div>
                  </div>
                  <div className="back-card">
                    <div id="bg-serv-3"></div>
                    <div className={`${i18n.language === "ar" ? "content-card-ar" : "content-card"}`}>
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 20.4 20.4" fill="none" stroke="#FFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-wrench-icon lucide-wrench"><path d="M12.495 5.355a0.85 0.85 0 0 0 0 1.19l1.36 1.36a0.85 0.85 0 0 0 1.19 0l3.204 -3.204a5.1 5.1 0 0 1 -6.749 6.749l-5.873 5.873a1.802 1.802 0 0 1 -2.55 -2.55l5.873 -5.873a5.1 5.1 0 0 1 6.749 -6.749l-3.196 3.196z"/></svg>
                      </div>
                      <div className="title-card">
                        {t('home.services.section.cards.three.back')}
                      </div>
                    </div>
                  </div>
                </div>
            </BlurFade>
          </div>
          <div>
            <BlurFade delay={0.25} inView>
              <a href={"/services"} className={`${i18n.language === "ar" ? "btn-explore-more-services-ar" : "btn-explore-more-services"} group`}>
                <div>
                  {t('home.services.section.explore')}
                </div>
                <div className="flex-default">
                  {i18n.language === "ar" ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-left-icon lucide-arrow-left transition-transform duration-150 group-hover:-translate-x-1"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-right-icon lucide-arrow-right transition-transform duration-150 group-hover:translate-x-1"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                  )}
                </div>
              </a>
            </BlurFade>
          </div>
        </div>

        <div className="container-text-reveal">
          <TextReveal>{t('home.services.section.text_reveal')}</TextReveal>
        </div>
      </div>
      
    </section>
  )
}
 
export default Services